import { connect } from 'react-redux';
import { confirmRosterPlayer } from '../../store/actions/localChanges';
import { editRosterPlayer, removeRosterPlayer, takeFaceCheck } from '../../store/actions/rosters';
import { isLoading } from '../../store/actions/app';
import { getRosters } from '../../util/reducer-helpers';
import { supports } from '../../util/context';
import { FACECHECK_ALLOWED, ROSTERS_LOCKED, ROSTERS_UNLOCKED } from '../../store/constants/statusCodes';
import RosterPlayers from '../../components/Pages/RosterPlayers';

const mapStateToProps = ( state, props ) => {

    // console.log( 'containers.Pages.RosterPlayers.mapStateToProps', state, props );

    const activeGame = state.items.games.activeItem;
    const rosters    = getRosters( state );
    let countables   = null;
    let rosterLimits = null;
    let facecheck    = null;
    let rosterStatus = null;
    let simpleLineup = false;

    if ( rosters.rosters && rosters.rosters.items ) {

        countables   = rosters.rosters.items.countables ? rosters.rosters.items.countables : null;
        rosterLimits = rosters.rosters.items.rosterLimits ? rosters.rosters.items.rosterLimits : null;
        facecheck    = props.team === 'home' ? rosters.rosters.items.facecheckHome : rosters.rosters.items.facecheckAway;
        rosterStatus = rosters.rosters.items.rosterStatus;
        simpleLineup = rosters.rosters.items.simpleLineup;

    }

    const cProps = {

        context:    state.auth.context,
        disabled:   activeGame.permission === 'referee' ? rosterStatus !== ROSTERS_LOCKED || facecheck !== FACECHECK_ALLOWED : rosterStatus !== ROSTERS_UNLOCKED || props.team !== activeGame.permission,
        lastUpdate: rosters.rosters && rosters.rosters.lastUpdate ? new Date( rosters.rosters.lastUpdate ) : null,
        roster:     props.team === 'home' ? rosters.mergedHomeRoster : rosters.mergedAwayRoster,
        teamId:     props.team === 'home' ? activeGame.homeTeam.id : activeGame.awayTeam.id,
        token:      state.auth.token,

        activeGame, countables, rosterLimits, facecheck, rosterStatus, simpleLineup

    };

    if ( supports( state.auth.context, 'teamOfficials' ) ) {

        cProps.teamOfficials = props.team === 'home' ? rosters.mergedHomeTeamOfficials : rosters.mergedAwayTeamOfficials;

    }

    return cProps;

};

const mapDispatchToProps = dispatch => {

    return {
        onConfirmRosterPlayer: ( gameId, playerId, isConfirmed                          ) =>                                  dispatch( confirmRosterPlayer( gameId, playerId, isConfirmed                          ) ),
        onEditRosterPlayer:    ( context, token, gameId, team, teamId, player           ) => dispatch( isLoading( true ) ) && dispatch( editRosterPlayer(    context, token, gameId, team, teamId, player           ) ),
        onRemoveRosterPlayer:  ( context, token, gameId, team, playerId, isTeamOfficial ) => dispatch( isLoading( true ) ) && dispatch( removeRosterPlayer(  context, token, gameId, team, playerId, isTeamOfficial ) ),
        onTakeFaceCheck:       ( context, token, gameId, team, teamId                   ) => dispatch( isLoading( true ) ) && dispatch( takeFaceCheck(       context, token, gameId, team, teamId                   ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( RosterPlayers );